import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { TRFPVendorsRequest, TRFPVendorsResponse } from '../types'

const fetcher = new Fetcher({})

export const getVendorUsers = async (id, data) =>
  fetcher.request<TRFPVendorsRequest, TRFPVendorsResponse>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.VENDORS}`,
    method: HTTP_METHODS.GET,
    ...data
  })
